import React,{ forwardRef, useMemo } from 'react';
import { BaseBlockProps } from '../types';
import {
    BlockWrapper,
    BlockHeader,
    BlockToolbar,
    ChartContainer,
} from '../base';
import { FunnelChart } from '../../../Components/Display';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface FunnelBlockProps extends BaseBlockProps {}

const DEFAULT_FUNNEL_DATA = [
    { id: 'step_qualification', label: 'Qualification', value: 15654 },
    { id: 'step_meeting', label: 'Meeting', value: 8765 },
    { id: 'step_proposal', label: 'Proposal', value: 5678 },
    { id: 'step_closing', label: 'Closing', value: 2345 },
];

export const FunnelBlock = forwardRef<HTMLDivElement, FunnelBlockProps>(
    (
        {
            kedo,
            block,
            dashboard,
            container,
            onClose,
            onMax,
            onSuccess,
            getBlockHeader,
            dossier,
        },
        ref
    ) => {
        const funnelData = useMemo(() => {
            return DEFAULT_FUNNEL_DATA.map((item) => ({
                ...item,
                label: kedo.t(item.label),
            }));
        }, [kedo]);

        return (
            <BlockWrapper
                ref={ref}
                dashboard={dashboard}
                height={container ? '300px' : '100%'}
                sx={{
                    marginBottom: '30px',
                    minHeight: '300px',
                    minWidth: '300px',
                }}
            >
                <BlockHeader>
                    <BlockToolbar
                        kedo={kedo}
                        block={block}
                        onClose={onClose}
                        onMax={onMax}
                        onSuccess={onSuccess}
                    />
                    {getBlockHeader?.(block, dossier)}
                </BlockHeader>
                <ChartContainer height="100%">
                    <FunnelChart data={funnelData} />
                </ChartContainer>
            </BlockWrapper>
        );
    }
);

FunnelBlock.displayName = 'FunnelBlock';
